import { h } from "preact";
import "./icon.scss";
import { IconSvg } from "./iconsvg";

export function Icon(props: { icon: string, selected?: boolean, class?: string }) {
    return (
        <div class="icon">
            {
                IconSvg(props.icon)
            }
        </div>
    );
}
